// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/AuditResult.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/AuditResult.tsx");
  import.meta.hot.lastModified = "1732036225890.0813";
}
// REMIX HMR END

import { Fragment } from "react";
import React2LighthouseViewer from "react2-lighthouse-viewer";
import ContentWrapper from "~/components/ContentWrapper";
import clsx from "clsx";
import DocTahedroidImage, { resultMapping } from "./DocTahedroidImage";
import OpengraphAuditResult from "./Opengraph/OpengraphAuditResult";
import CoreWebVitals from "./CoreWebVitals/CoreWebVitals";
import IconResolver from "~/components/IconResolver";
import { calculateAttributesPassing, getDisclaimer } from "./utils";
import AuditShare from "./AuditShare";
import Heading from "~/components/Heading";
export default function AuditResult({
  audit,
  isLoading,
  isStreaming = false,
  reportId
}) {
  if (isLoading) {
    const {
      speed: {
        title,
        message
      }
    } = resultMapping[isStreaming ? "waitingFull" : "waiting"];
    return <ContentWrapper Item="div" spacing="primary" className="w-full bg-neutral-100">
        <section className={clsx("flex flex-col items-center", "md:grid md:grid-cols-20 md:text-left md:items-stretch")}>
          <hgroup className={clsx("md:col-span-9 md:row-start-1", "md:col-start-1")}>
            <Heading tag="h2" className="flex items-center">
              <IconResolver token="spinner" className="w-5 h-5 animate-spin mr-3" />{" "}
              {title}
            </Heading>
            <p className="text-neutral-600">{message}</p>
          </hgroup>
          <DocTahedroidImage className={clsx("mt-4 md:mt-0 self-center object-scale-down md:col-span-9 md:row-start-1", "md:col-start-12")} variant="waiting" />
        </section>
      </ContentWrapper>;
  }
  if (!audit) return null;
  const auditKind = audit.opengraph ? "opengraph" : "speed";
  const auditAttributes = calculateAttributesPassing(audit);
  const {
    [auditKind]: {
      title,
      message
    },
    diagnosisColor,
    image,
    isResult
  } = resultMapping[auditAttributes?.variant || "boost"];
  const disclaimer = getDisclaimer(audit);
  return <Fragment>
      <ContentWrapper Item="div" spacing="primary" className="w-full bg-neutral-100">
        <section className={clsx("flex flex-col items-center", "md:grid md:grid-cols-20 md:text-left md:items-stretch")}>
          <hgroup className={clsx("md:col-span-9 md:row-start-1", "md:col-start-1")}>
            <Heading tag="h2" className="flex items-center">
              {title}
            </Heading>
            {audit.crux && <CoreWebVitals pass={audit.crux.pass} cls={audit.crux.cls} inp={audit.crux.inp} lcp={audit.crux.lcp} />}
            <p className="text-neutral-600">{message}</p>
            {reportId && isResult && auditAttributes?.variant === "approval" && <AuditShare reportId={reportId} reportKind={auditKind === "speed" ? "performance" : "opengraph"} />}
            {disclaimer && <p className="text-xs text-neutral-600 mt-4">{disclaimer}</p>}
          </hgroup>
          <DocTahedroidImage className={clsx("mt-4 md:mt-0 self-center object-scale-down md:col-span-9 md:row-start-1", "md:col-start-12")} variant={image} />
        </section>
      </ContentWrapper>
      {audit.opengraph && <OpengraphAuditResult cards={audit.opengraph} />}

      {audit.psi && <ContentWrapper spacing="primary" Item="section" className="w-full bg-white flex-col items-center [&_.lh-topbar]:z-0 ">
          <Heading tag="h2" className="text-center mt-4">
            PageSpeed Insights Report
          </Heading>
          <React2LighthouseViewer json={audit.psi} />
        </ContentWrapper>}
    </Fragment>;
}
_c = AuditResult;
var _c;
$RefreshReg$(_c, "AuditResult");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;